import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('submitting');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6nakcaqoe30lj0v8l1g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus('idle'), 5000);
      }
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  return (
    <footer id="contact" className="relative" style={{ backgroundColor: '#0D3D3D' }}>
      <div className="max-w-7xl mx-auto px-8 pt-20 pb-12">
        <div className="grid grid-cols-4 gap-16 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/ce3861b4-1e99-4774-b56d-0a3e475a675b.png" 
                alt="TEAL SRL Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-semibold" style={{ color: '#F5F0E8' }}>
                TEAL SRL
              </span>
            </div>
            <div className="space-y-2 text-sm leading-relaxed" style={{ color: '#B8C5C5', lineHeight: '1.8' }}>
              <p>iOS Development Experts</p>
              <p>Premium Applications</p>
              <p>Since 2020</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 font-medium" style={{ color: '#9EADAD', letterSpacing: '1.5px' }}>
              Location
            </h4>
            <div className="space-y-3 pb-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
              <p className="text-base" style={{ color: '#FFFFFF' }}>VIA ANTONIO PACINOTTI 1/D-3</p>
              <p className="text-base" style={{ color: '#FFFFFF' }}>ROMA, 00146</p>
              <p className="text-base" style={{ color: '#FFFFFF' }}>Italy</p>
            </div>
            <p className="text-xs mt-3" style={{ color: '#7A8A8A' }}>Headquarters</p>
          </div>
          
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 font-medium" style={{ color: '#9EADAD', letterSpacing: '1.5px' }}>
              Email
            </h4>
            <a 
              href="mailto:info@teal-srl.com"
              className="text-base hover:underline transition-all duration-200"
              style={{ color: '#FFFFFF' }}
            >
              info@teal-srl.com
            </a>
          </div>
          
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 font-medium" style={{ color: '#9EADAD', letterSpacing: '1.5px' }}>
              Phone
            </h4>
            <a 
              href="tel:+18203483458"
              className="text-base hover:underline transition-all duration-200"
              style={{ color: '#FFFFFF' }}
            >
              +1 8203483458
            </a>
          </div>
        </div>

        <div className="border-t pt-16 pb-8" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <h3 className="text-center mb-12 text-xs uppercase tracking-widest" style={{ color: '#9EADAD', letterSpacing: '1.5px' }}>
            Get In Touch
          </h3>
          
          <form 
            id="contact-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="max-w-3xl mx-auto"
          >
            <div className="grid grid-cols-2 gap-6 mb-6">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-5 py-4 rounded-lg text-sm bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors duration-200"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-5 py-4 rounded-lg text-sm bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors duration-200"
                />
              </div>
            </div>
            
            <div className="mb-6">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                required
                className="w-full px-5 py-4 rounded-lg text-sm bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors duration-200"
              />
            </div>
            
            <div className="mb-6">
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={(e) => {
                  if (e.target.value.length <= 500) {
                    setFormData({ ...formData, message: e.target.value });
                  }
                }}
                required
                rows={6}
                maxLength={500}
                className="w-full px-5 py-4 rounded-lg text-sm bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors duration-200 resize-none"
              ></textarea>
              <p className="text-xs mt-2 text-right" style={{ color: '#7A8A8A' }}>
                {formData.message.length}/500 characters
              </p>
            </div>
            
            <div className="text-center">
              <button
                type="submit"
                disabled={submitStatus === 'submitting'}
                className="px-10 py-4 rounded-lg font-medium text-sm uppercase tracking-wider transition-all duration-200 hover:opacity-90 disabled:opacity-50 whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#E8DCC8', color: '#0D3D3D' }}
              >
                {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
              </button>
              
              {submitStatus === 'success' && (
                <p className="mt-4 text-sm" style={{ color: '#4ADE80' }}>
                  Message sent successfully! We&apos;ll get back to you soon.
                </p>
              )}
              
              {submitStatus === 'error' && (
                <p className="mt-4 text-sm" style={{ color: '#F87171' }}>
                  Failed to send message. Please try again.
                </p>
              )}
            </div>
          </form>
        </div>
        
        <div className="mt-20 text-center">
          <div 
            className="text-9xl font-bold tracking-tight"
            style={{ 
              color: '#E8DCC8',
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '-4px'
            }}
          >
            TEAL
          </div>
        </div>
      </div>
    </footer>
  );
}